export const dropdownItems = ['Edit Profile', 'API Management', 'Change Password', 'Log Out'];